import { ErrorData } from 'hls.js';

/***
 * This monkey patch method needed because in Hls v1, when subtitle playlist fetch errors out
 * then hls.js throwing fatal error which causing fallback. In earlier version of hls.js,
 * it used to throw fatal = false. (AV-30246)
 */
export function monkeyPatchErrorOutMethod(hlsPlayer: any): void {
	const errorController = hlsPlayer.player.networkControllers.find(controller => 'onErrorOut' in controller);

	if (errorController) {
		const originalFunction = errorController.onErrorOut;

		if (originalFunction) {
			errorController.onErrorOut = function(...args: any[]) {
				const data = args[1] as ErrorData;
				if (data.errorAction && (data.details === hlsPlayer.Hls.ErrorDetails.SUBTITLE_LOAD_ERROR || data.details === hlsPlayer.Hls.ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT)) {
					data.errorAction.resolved = true;
				}
				return originalFunction.apply(this, args);
			};

			hlsPlayer.player.off(hlsPlayer.HlsEvents.ERROR, originalFunction, errorController);
			const onErrorOut = errorController.onErrorOut;
			hlsPlayer.player.on(hlsPlayer.HlsEvents.ERROR, onErrorOut, errorController);
		}

	}

}
